(function () {
  var SIZE_HINTS = ['size', 'größe', 'groesse', 'grösse'];

  function isSizeOption(name) {
    var n = (name || '').toLowerCase();
    return SIZE_HINTS.some(function (hint) {
      return n.indexOf(hint) !== -1;
    });
  }

  function parseJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function getOptionLabel(card, input) {
    var label = input.id ? card.querySelector('label[for="' + input.id + '"]') : null;
    if (label) return label.textContent.replace(/\s+/g, ' ').trim();
    return input.value;
  }

  function getSelectedOptions(card) {
    var selected = {};
    card.querySelectorAll('.product-card__info [type="radio"]:checked').forEach(function (input) {
      var position = input.getAttribute('data-option-position');
      if (!position) return;
      selected[position] = getOptionLabel(card, input);
    });
    return selected;
  }

  function findVariant(card, sizeName) {
    var picker = card.querySelector('[data-pnty-card-sizes]');
    if (!picker) return null;

    var variants = parseJson(picker.querySelector('[data-pnty-variants]'), []);
    var options = parseJson(picker.querySelector('[data-pnty-options]'), []);
    var selected = getSelectedOptions(card);
    var sizeIndex = -1;

    options.forEach(function (name, index) {
      if (isSizeOption(name)) sizeIndex = index;
    });

    if (sizeIndex === -1) return null;

    return variants.find(function (variant) {
      if (!variant.available) return false;
      var optionKey = 'option' + (sizeIndex + 1);
      if (variant[optionKey] !== sizeName) return false;

      return options.every(function (name, index) {
        if (isSizeOption(name)) return true;
        var key = 'option' + (index + 1);
        var chosen = selected[String(index + 1)];
        return !chosen || variant[key] === chosen;
      });
    });
  }

  function refreshButtons(card) {
    var picker = card.querySelector('[data-pnty-card-sizes]');
    if (!picker) return;

    picker.querySelectorAll('[data-pnty-size]').forEach(function (button) {
      var sizeName = button.getAttribute('data-pnty-size');
      var variant = findVariant(card, sizeName);
      var soldOut = !variant;

      button.classList.toggle('is-sold-out', soldOut);
      button.disabled = soldOut;
      button.setAttribute('aria-disabled', soldOut ? 'true' : 'false');

      if (variant) {
        button.setAttribute('data-variant-id', String(variant.id));
      } else {
        button.removeAttribute('data-variant-id');
      }
    });
  }

  async function addVariantToCart(variantId) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('sections', sectionsToBundle.join(','));
    body.append('sections_url', (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'variants/' + variantId);
    body.append('on_success', 'force_open_drawer');

    var response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    var responseJson = await response.json();

    if (!response.ok) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: responseJson.description || 'Could not add to cart' }
        })
      );
      return;
    }

    var cartContent = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')).json();
    cartContent.sections = responseJson.sections;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer',
          cart: cartContent
        }
      })
    );
  }

  function onSizeClick(event) {
    var button = event.target.closest('[data-pnty-size]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var card = button.closest('product-card');
    if (!card) return;

    var sizeName = button.getAttribute('data-pnty-size');
    var variant = findVariant(card, sizeName);
    if (!variant) return;

    button.classList.add('is-adding');
    addVariantToCart(variant.id).finally(function () {
      button.classList.remove('is-adding');
    });
  }

  function onSwatchChange(event) {
    var card = event.target.closest('product-card');
    if (card) refreshButtons(card);
  }

  function onFigureClick(event) {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var figure = event.currentTarget;
    var card = figure.closest('product-card');
    if (!card || !card.querySelector('[data-pnty-card-sizes]')) return;

    if (event.target.closest('[data-pnty-card-sizes]')) return;

    event.preventDefault();
    card.classList.toggle('is-size-open');
  }

  function initCard(card) {
    if (!card.querySelector('[data-pnty-card-sizes]')) return;
    refreshButtons(card);
  }

  function init() {
    document.querySelectorAll('product-card').forEach(initCard);

    document.addEventListener('click', onSizeClick);
    document.addEventListener('change', onSwatchChange);

    document.querySelectorAll('.product-card__figure').forEach(function (figure) {
      if (!figure.querySelector('[data-pnty-card-sizes]')) return;
      figure.addEventListener('click', onFigureClick);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('product-card.is-size-open')) return;
      document.querySelectorAll('product-card.is-size-open').forEach(function (card) {
        card.classList.remove('is-size-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
